import { ButtonBase, Grid, IconButton, Typography } from '@material-ui/core';
import React from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colors } from 'design-system';

// Icons
import { FilterIcon, LightIcon } from '../../../Icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchArea: {
      backgroundColor: colors.onahau,
      maxHeight: 600,
      overflow: 'hidden',
      transition: 'max-height 0.5s cubic-bezier(1, 1, 0, 1)',
      width: '100%',
    },
    searchAreaInputWrapper: {
      backgroundColor: colors.white,
      borderRadius: 10,
      border: 'none',
      fontFamily: 'Poppins',
      padding: 2,
      margin: theme.spacing(2, 2, 2, 3.75),
      position: 'relative',
    },
    searchAreaInput: {
      width: `calc(90% - ${theme.spacing(1)}px)`,
      height: 29,
      marginTop: 2,
      fontFamily: 'Noto Sans SC',
      border: 'none',
      marginLeft: theme.spacing(1),
      '&:focus': {
        outline: 'none',
      },
    },
    searchHint: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(0, 3.75, 2, 3.75),
    },
  }),
);

function makeClearButton(onClick: () => void): JSX.Element {
  return (
    <ButtonBase data-testid="clear-search-button" onClick={onClick}>
      <img alt="clear search" src="./svg/search_clear_icon.svg" />
    </ButtonBase>
  );
}

function makeSearchMsg(): JSX.Element {
  return (
    <>
      <LightIcon />
      <Typography variant="caption">
        Puedes buscar por nombre y apellido, por # de referencia o por usuario
      </Typography>
    </>
  );
}

function makeSearchIcon(): JSX.Element {
  return (
    <img
      style={{
        marginTop: 7,
        marginLeft: 7,
      }}
      src="./svg/gray_search.svg"
      alt="search"
    />
  );
}

type Props = {
  searchVisible: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  searchText: string;
  updateSearchText: (searchText: string) => void;
  toggleFilterDrawer: (filterDrawerIsOpen: boolean) => void;
};

const SearchToolbarOnlyMobile = ({
  searchVisible,
  inputRef,
  searchText,
  updateSearchText,
  toggleFilterDrawer,
}: Props): JSX.Element => {
  const classes = useStyles();

  function clearSearch(): void {
    updateSearchText('');
  }

  return (
    <div
      data-testid="search-container"
      className={classes.searchArea}
      style={{
        maxHeight: searchVisible ? 600 : 0,
      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={10}>
          <div className={classes.searchAreaInputWrapper}>
            <Grid container alignItems="center">
              <Grid item xs={1}>
                {makeSearchIcon()}
              </Grid>
              <Grid item xs={10}>
                <input
                  id="sales-web-input-search"
                  data-testid="search-input"
                  ref={inputRef}
                  type="text"
                  className={classes.searchAreaInput}
                  placeholder="Buscar..."
                  value={searchText}
                  onChange={(e): void => updateSearchText(e.target.value)}
                />
              </Grid>
              {searchText !== '' && (
                <Grid item xs={1}>
                  {makeClearButton(clearSearch)}
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        <IconButton
          id="sales-web-button-filterbutton"
          data-testid="filter-btn"
          onClick={() => toggleFilterDrawer(true)}
        >
          <FilterIcon strokeWidth="2px" />
        </IconButton>
      </Grid>
      <div className={classes.searchHint}>{makeSearchMsg()}</div>
    </div>
  );
};

export default SearchToolbarOnlyMobile;
